import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { IMAGES } from "../../lib/data";

const QUICK = ["Home", "Products", "About", "Dealers", "Contact"];
const FUTURE = ["Warranty", "Support", "Downloads", "Service Centers", "Spare Parts", "Privacy Policy", "Terms & Conditions"];
const SOCIAL = [
  { icon: Linkedin, label: "LinkedIn" },
  { icon: Facebook, label: "Facebook" },
  { icon: Instagram, label: "Instagram" },
  { icon: Youtube, label: "YouTube" },
];

export default function Footer() {
  return (
    <footer className="relative bg-[#050505] border-t border-white/5 pt-16 pb-8" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <img src={IMAGES.logo} alt="Sobtrex" className="h-16 w-auto" />
            <p className="mt-5 text-sm text-zinc-500 leading-relaxed max-w-xs">
              Powering Professionals. Built to Last. A premium professional power tools brand,
              launching soon across India.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIAL.map((s) => (
                <button
                  key={s.label}
                  aria-label={s.label}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  className="h-10 w-10 flex items-center justify-center border border-zinc-800 text-zinc-400 hover:border-orange-500 hover:text-orange-500 transition-colors"
                >
                  <s.icon size={18} />
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Quick Links</h4>
            <ul className="mt-5 space-y-3">
              {QUICK.map((q) => (
                <li key={q}>
                  <a href={`#${q === "Home" ? "home" : q === "Dealers" ? "dealers" : q === "Contact" ? "contact" : q.toLowerCase()}`}
                    className="text-sm text-zinc-500 hover:text-orange-500 transition-colors">{q}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-1">
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Future Pages</h4>
            <ul className="mt-5 grid grid-cols-1 gap-3">
              {FUTURE.map((f) => (
                <li key={f} className="flex items-center gap-2 text-sm text-zinc-600 cursor-not-allowed" title="Coming Soon">
                  {f}
                  <span className="text-[9px] font-bold uppercase tracking-wider text-orange-500/60 border border-orange-500/20 px-1.5 py-0.5">Soon</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Get in Touch</h4>
            <ul className="mt-5 space-y-3 text-sm text-zinc-500">
              <li>info@sobtrex.com</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">© 2026 Sobtrex. All Rights Reserved.</p>
          <a href="/admin/login" className="text-xs text-zinc-700 hover:text-orange-500 transition-colors" data-testid="footer-admin-link">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
